import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Navigation from 'components/Navigation';
import PageHeader, {
  PageHeaderContent,
  PageHeaderTitle,
} from 'components/PageHeader';
import PageBody from 'components/PageBody';
import FormsView from 'views/FormsView';
import { useTrackPage } from 'hooks/tracking';
import FlexPayBanner from 'components/FlexpayBanner';

function App() {
  const { t } = useTranslation();
  const location = useLocation();
  useTrackPage(location.pathname);
  return (
    <div className="App">
      <Navigation />
      <PageHeader>
        <PageHeaderContent>
          <PageHeaderTitle>{t('page.title')}</PageHeaderTitle>
        </PageHeaderContent>
      </PageHeader>
      <FlexPayBanner />
      <PageBody>
        <FormsView />
      </PageBody>
    </div>
  );
}

export default App;
